<template>
  <div class="news">
    <Loader v-if="isLoading" />

    <div class="container" v-if="!isLoading">
      <div class="h4">Новости</div>
      <div class="news-list">
        <NewsItem v-for="(item, i) in newsList" :key="i" :data="item" />
      </div>
      <PagePagination :pages="pages" :initial="initialPage" @changePage="changePage" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PagePagination from '@/components/PagePagination.vue';
import NewsItem from '@/components/News/NewsItem.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'News',
  components: { Loader, NewsItem, PagePagination },
  data() {
    return {
      isLoading: true,
      perPage: 6,
    };
  },
  computed: {
    ...mapState({
      newsCount: (state) => state.news.newsCount,
      newsList: (state) => state.news.newsList,
    }),
    pages() {
      return Math.ceil(this.newsCount / this.perPage);
    },
    initialPage() {
      return Number(this.$route.query.page) || 1;
    },
  },
  methods: {
    loadData(page) {
      this.$store.dispatch('getNewsCount', {})
        .then(() => this.$store.dispatch('getNewsList', { limit: 6, page }))
        .then(() => {
          this.isLoading = false;
        });
    },
    changePage(page) {
      this.$router.push({ query: { ...this.$router.currentRoute.query, page } }).catch((err) => err);
      this.loadData(page);
    },
  },
  mounted() {
    this.isLoading = true;
    this.loadData(this.initialPage);
    this.$emit('setLastCrumb', 'Новости');
  },
};
</script>
